module.exports = __webpack_public_path__ + "img/banner-right.4500f153.jpeg";